import React, { useEffect, useState, useCallback, useMemo, useContext } from "react";
import axios from "axios";
import { Header } from "./components/header";
import { Footer } from "./components/footer";

import "./detail.css";
import "./subcategory.css"
import { Content, LikesData, ShelfSetting } from "./globalType";
import { displayDuration, displayNumber, getHost, translate } from "./utils";
import { SubCatSubMenu, SubMenu } from "./components/submenu";
import { useParams } from "react-router-dom";
import { Popup } from "./components/popup";
import { likeContent } from "./api";
import { AuthContext } from "./auth";
import { TailSpin } from "react-loader-spinner";

declare var $: any;

type SubcatProps = {
  goToPage: (page: string, content: Content | null) => void;
};

function HomeSubcategory(props: SubcatProps) {
  const {subcategorySlug} = useParams()
  const { goToPage } = props;
  const [popup, setPopup] = useState<Content | null>(null);
  const [subcategories, setSubcategoriesItems] = useState<Content[]>([])
  const [likesData, setLikesData] = useState<LikesData | null>(null)
  const [settings, setSettings] = useState<ShelfSetting | null>(null)

  const authContext = useContext(AuthContext);

  useEffect(() => {
    if (subcategorySlug) {
      fetchContents(subcategorySlug)
    }
    
  }, []);

  const fetchContents = async (slug:string) => {
    try {
      const result = await fetchShelf(slug);
       setSubcategoriesItems(result.data.shelf_items);
       setSettings(result.data.setting)
    } catch (error) {
      console.log(error);
    }
  };

  const handlePopupVideoMouseLeave = useMemo(
    () => () => {
      $(".popupVideo>.detail").hide();
    },
    []
  );

  const likes = async (contentId:string | undefined) => {
    if (!contentId) return;
    if (likesData && likesData[contentId]) {
      setLikesData({
        ...likesData,
        [contentId]: false,
      })
      return;
    }
    const result = await likeContent(contentId, authContext?.user?.profile.access_token)
    if (!result) return;

    setLikesData({
      ...likesData,
      [contentId]: true,
    })
  }

  return (
    <>
      <Header goToPage={goToPage} />
      {!subcategories && (
        <div className="d-flex justify-content-center align-items-center" style={{height: '100vh'}}>
        <TailSpin color="#00BFFF" height={150} width={150} />
        </div>
      )}
      <div className="subMenu-BG">
        <div className="container H-container">
            <div className="subMenu">
                <div className="mobile">
                    <img src="/ondemand/static/img/search.png" alt="" />
                </div>
                <div onClick={() => {goToPage('/ondemand/', null)}} className='bold'>Home</div>
                <div className="bold active">
                    <span>{translate(settings?.title_th, settings?.title_en, authContext?.lang)}</span>
                </div>
            </div>
        </div>
    </div>

      {subcategories.length > 0 && (
        <div className="main-container w-100">
          <div className="main">
            {subcategories.map((item, index) => (
              <CarouselItem
              goToPage={goToPage}
                key={item.id}
                content={item}
                setPopup={setPopup}
                viewType="poster"
                index={index}
              />
            ))}
          </div>
        </div>
      )}

      <Popup popup={popup} goToPage={goToPage} likes={likes} likesData={likesData} />
      <Footer />
    </>
  );
}


interface CarouselItemProps {
  content: Content;
  setPopup: React.Dispatch<React.SetStateAction<Content | null>>;
  viewType: string;
  index: number;
  goToPage: (page: string, content: Content | null) => void;
}
export function CarouselItem(props: CarouselItemProps) {
  const { content, setPopup, viewType, goToPage } = props;
  const handlePopupChange = useCallback(() => {
    setPopup(content);
  }, [content, setPopup]);

  const w_device = $(window).width();

  const handleImageMouseEnter = useMemo(
    () => (evt: React.MouseEvent) => {
      handlePopupChange();
      
      let w = $(evt.target).width();
      let h = $(evt.target).height();
      let pos = $(evt.target).offset();
      let l = pos.left + w / 2 < 160 ? 160 : pos.left + w / 2;
      let per_min = (pos.left / w_device) * 100;
      let per_max = (l / w_device) * 100;

      if (per_max > 20 && per_min < 12) l = "220px";

      if ($(evt.target).attr("landscape")) {
        if (per_max > 70) {
          l = "81vw";
        }
      }

      $(".popupVideo").css({
        top: pos.top + h / 2,
        left: l,
      });

      $(".popupVideo>.detail").css({
        width: `${w * 1.1 > 360 ? w * 1.1 : 360}px`,

        height: `${h * 1.1 > 380 ? w * 1.1 : 380}px`,
      });

      if (per_max < 20 && per_min < 12) {
        $(".popupVideo").css({
          top: pos.top + h / 2,
          left: 360/2 + w_device * 0.04,
          right: "auto",
          width: `${w * 1.1 > 360 ? w * 1.1 : 360}px`,
          height: `auto`,
        });

        $(".popupVideo>.detail").fadeIn("100");
      } else if (per_max > 85) {
        $(".popupVideo").css({
          top: pos.top + h / 2,
          left: w_device - 360/2 - (w_device * 0.04),
          width: `${w * 1.1 > 360 ? w * 1.1 : 360}px`,
          height: `auto`,
        });
        $(".popupVideo>.detail").fadeIn("100");
      } else {
        $(".popupVideo>.detail").hide();
        $(".popupVideo>.detail").fadeIn("100");
      }
    },
    [handlePopupChange, viewType, w_device]
  );

  let handleMouseEnter: any = () => {}
  if (w_device >= 1200) {
    handleMouseEnter = handleImageMouseEnter
  }

  return (
    <div className="p-3">
      <img
        src={content.thumb_list.poster}
        onClick={() => {goToPage(`/ondemand/detail/${content.id}`, content)}}
        alt=""
        onMouseEnter={handleMouseEnter}
      />
    </div>
  );
}

async function fetchShelf(shelf:string) {
  const host = getHost()
  return axios.get(`${host}/api/series/${shelf}`);
}

export default HomeSubcategory;
